import { type Meta } from '../types/docs';
import { SKILL_ANALYTICS_TYPES } from './skillAnalytics';

const META: Meta = {
  description: 'Fired when a user successfully deletes a skill',
  name: 'skill_deleted',
  params: [
    {
      description: 'ID of the deleted skill',
      name: 'skill_id',
      required: true,
      type: 'string',
    },
    {
      description: 'Scope of the skill at time of deletion',
      name: 'scope',
      required: true,
      type: 'enum',
      values: ['private', 'workspace', 'builtIn'],
    },
    {
      description: 'Skill surface',
      name: 'type',
      required: true,
      type: 'enum',
      values: [...SKILL_ANALYTICS_TYPES],
    },
  ],
};

export default META;
